import {Close} from "@radix-ui/react-dialog";
import {Cross2Icon} from "@radix-ui/react-icons";
import type {ChangelogResp} from "data/changelog/api";
import {Icons, Tags} from "./mini-changelog";
import {isInArray} from "@sensoteq/core";

type Props = {
  releasedAt: string;
  changelog: ChangelogResp;
};

export function ChangelogHeader(props: Props) {
  return (
    <div
      style={{minHeight: 26}}
      className="border-b flex flex-row items-center border-content-placeholder py-4"
    >
      <div
        style={{
          fontSize: "1.4rem",
        }}
        className="px-12 text-secondary-foreground-alt"
      >
        {props.releasedAt}
      </div>
      <div className="flex flex-row justify-between items-center flex-1 mr-16">
        <div
          className="flex flex-row gap-5 flex-wrap"
          style={{marginLeft: 10}}
        >
          {props.changelog.tags.map((tag) => {
            const key = isInArray(tag, Tags) ? tag : "generic";
            const icon = Icons[key].main;
            return (
              <div
                key={tag}
                className="flex flex-row items-center rounded-full border border-content-placeholder px-4"
                style={{paddingTop: 5, paddingBottom: 5}}
              >
                <div>{icon}</div>
                <div className="pl-4 cursor-default">{tag}</div>
              </div>
            );
          })}
        </div>
      </div>
      <Close
        style={{marginTop: 1, position: "absolute", right: 2}}
        className="w-10 h-10 rounded-lg flex flex-row items-center justify-center text-content-main-menu-text hover:!bg-secondary-hover hover:text-secondary-foreground mr-4 cursor-default"
      >
        <Cross2Icon className="h-8 w-8" />
      </Close>
    </div>
  );
}
